export class RespostaUsuarioCns {

    sucesso: boolean;
    usuarioSUS: UsuarioCns= new UsuarioCns();
}

export class UsuarioCns {
    nome: string;
    numeroCNS: string;
    numeroCPF: string;
    numeroRG: string;
    email: string;
    ddTelefone: string;
    numTelefone: string;
}



// WEBPACK FOOTER //
// ./src/app/model/usuario-cns.ts